import RequestContextService from '../RequestContextService.js';
import getBaseUrl from './getBaseUrl.js';

export default async function redirectToLogin() {
  const baseUrl = getBaseUrl();

  return fetch(`${baseUrl}/authentication-logout`, {
    headers: {
      Accept: 'application/json',
      'Accept-encoding': 'gzip'
    },
    method: 'POST'
  }).finally(() => {
    RequestContextService.clear();
    window.location.reload();
  });
}
